import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Layout, Menu } from "antd";
import { USER_STORAGE, ROLE_ADMIN, ROLE_USER_ADMIN } from "constants/index";
import { useSelector } from "react-redux";
import { selectRole } from "reducer/login/login-user";
import { Menu as MenuIcon } from "lucide-react";
import {
  Compass,
  KeyRound,
  Landmark,
  MoveDownRight,
  Boxes,
  CalendarDays,
  Settings,
  FileInput,
  SquareArrowOutUpRight,
  Ruler,
  ChartCandlestick,
  WalletMinimal,
  CircleDollarSign,
  Users,
  Layers3,
  NotebookText,
  Download,
} from "lucide-react";
import { GetPropsMenu } from "./menu-custom";

const { Sider } = Layout;
const LOGO = require("images/login/logo-fipra-2-horizontal-negativo.png");

const MenuApp = () => {
  const navigate = useNavigate();
  const [roleRedux, setRoleRedux] = useState(useSelector(selectRole));
  const [collapsed, setCollapsed] = useState(false);
  const customMenu = GetPropsMenu(location.pathname);
  const [collapsedIcon, setCollapsedIcon] = useState({
    dash: null,
    financial: null,
    financialAdm: null,
    setting: null,
  });

  useEffect(() => {
    const localStorageItem = localStorage.getItem(USER_STORAGE);
    if (localStorageItem != null && roleRedux == "") {
      const { role } = JSON.parse(localStorageItem);
      setRoleRedux(role);
    }
  }, []);

  function getCompanyType() {
    const localStorageItem = localStorage.getItem(USER_STORAGE);
    const { companyType } = JSON.parse(localStorageItem);
    return companyType;
  }
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1350) {
        // ajuste o valor conforme necessário
        setCollapsed(true);
        setCollapsedIcon({
          dash: <ChartCandlestick size={20} style={{ marginLeft: "20px" }} />,
          financial: <WalletMinimal size={20} style={{ marginLeft: "20px" }} />,
          setting: <Settings size={20} style={{ marginLeft: "20px" }} />,
          financialAdm: (
            <CircleDollarSign size={20} style={{ marginLeft: "20px" }} />
          ),
        });
      } else {
        setCollapsed(false);
        setCollapsedIcon({
          dash: null,
          financial: null,
          setting: null,
          financialAdm: null,
        });
      }
    };

    window.addEventListener("resize", handleResize);

    // Chame a função uma vez para definir o estado inicial
    handleResize();

    // Limpe o event listener quando o componente for desmontado
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  function getItem(label, key, icon, children, type, router) {
    return {
      key,
      icon,
      children,
      label,
      type,
      onClick: () => {
        if (router) navigate(router);
      },
    };
  }
  const itemsUser = [
    getItem("Dashboard", "sub1", collapsedIcon.dash, [
      getItem(
        "Painel Gerencial",
        "1",
        <Compass size={15} />,
        null,
        null,
        "/app/client/managerial"
      ),
      getItem(
        "KPI",
        "2",
        <KeyRound size={15} />,
        null,
        null,
        "/app/client/kpi/cash-flow-v2"
      ),

      getItem(
        "Receita",
        "4",
        <Landmark size={15} />,
        null,
        null,
        "/app/client/revenues"
      ),
      getItem(
        "Despesas",
        "5",
        <MoveDownRight size={15} />,
        null,
        null,
        "/app/client/expenses"
      ),
    ]),
    getItem("Financeiro", "sub2", collapsedIcon.financial, [
      getItem(
        "Fluxo de Caixa Diário",
        "6",
        <Boxes size={15} />,
        null,
        null,
        "/app/client/cash-flow"
      ),
      getItem(
        "Fluxo de Caixa Mensal",
        "7",
        <CalendarDays size={15} />,

        null,
        null,
        "/app/client/cash-flow-month"
      ),
      getItem(
        "DRE Gerencial",
        "8",
        <Settings size={15} />,
        null,
        null,
        "/app/client/income-statement-v2"
      ),
      getItem(
        "Contas à Pagar",
        "9",
        <FileInput size={15} />,
        null,
        null,
        "/app/client/bills-pay"
      ),
      getItem(
        "Contas à Receber",
        "10",
        <SquareArrowOutUpRight size={15} />,
        null,
        null,
        "/app/client/bills-receive"
      ),
      getItem(
        "Centro de Custo",
        "101",
        <Ruler size={15} />,
        null,
        null,
        "/app/client/cost-center"
      ),
    ]),
    /*   getItem("Contábil", "sub3", <ReadOutlined />, [
      getItem("DRE", "11", null, null, null, "/app/client/accounting-income"),
      getItem(
        "DFC",
        "12",
        null,
        null,
        null,
        "/app/client/accounting-cash-flow"
      ),
      getItem(
        "Balanço",
        "13",
        null,
        null,
        null,
        "/app/client/accounting-balance"
      ),
      getItem("Contábil", "3", null, null, null, "/app/client/accounting"),
    ]),*/
  ];

  const itemsUserBi = [
    getItem("Dashboard", "sub1", collapsedIcon.dash, [
      getItem(
        "Painel Gerencial",
        "1",
        <Compass size={15} />,
        null,
        null,
        "/app/client/managerial"
      ),
    ]),
  ];
  const itemsAdmin = [
    getItem("Configuração", "sub1", collapsedIcon.setting, [
      getItem(
        "Clientes",
        "1",
        <Users size={15} />,
        null,
        null,
        "/app/admin/client"
      ),
      getItem(
        "Usuários",
        "2",
        <Users size={15} />,
        null,
        null,
        "/app/admin/user"
      ),
      getItem(
        "Categorias",
        "22",
        <Layers3 size={15} />,
        null,
        null,
        "/app/admin/category"
      ),
      getItem(
        "Plano de contas FC",
        "235",
        <NotebookText size={15} />,
        null,
        null,
        "/app/admin/mapping-cash-flow"
      ),
      getItem(
        "Plano de contas DRE",
        "231",
        <NotebookText size={15} />,
        null,
        null,
        "/app/admin/mapping-income"
      ),

      getItem(
        "Importação de dados",
        "4",
        <Download size={15} />,
        null,
        null,
        "/app/admin/import"
      ),
    ]),
    getItem("Financeiro", "sub2", collapsedIcon.financialAdm, [
      getItem(
        "Fluxo de Caixa Mensal",
        "111",
        <CalendarDays size={15} />,
        null,
        null,
        "/app/admin/cash-flow"
      ),
      getItem(
        "DRE Gerencial",
        "211",
        <Settings size={15} />,
        null,
        null,
        "/app/admin/income"
      ),
    ]),
  ];
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
    if (!collapsed == true) {
      setCollapsedIcon({
        dash: <ChartCandlestick size={20} style={{ marginLeft: "20px" }} />,
        financial: <WalletMinimal size={20} style={{ marginLeft: "20px" }} />,
        setting: <Settings size={20} style={{ marginLeft: "20px" }} />,
        financialAdm: (
          <CircleDollarSign size={20} style={{ marginLeft: "20px" }} />
        ),
      });
    } else {
      setCollapsedIcon({
        dash: null,
        financial: null,
        setting: null,
        financialAdm: null,
      });
    }
  };

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={() => toggleCollapsed()}
      className="container-sider"
      id="siderMenu"
      width={"15%"}
      trackStyle={{ backgroundColor: "#12475c" }}
    >
      <div className="top-menu">
        <div
          onClick={toggleCollapsed}
          style={{
            marginBottom: 16,
            cursor: "pointer",
            color: "#ffffff",
            textAlign: "end",
            paddingRight: "15px",
          }}
        >
          {collapsed ? <MenuIcon size={20} /> : <MenuIcon size={20} />}
        </div>
        {!collapsed && <img className="logo-login" src={LOGO} alt="Logo" />}
      </div>

      <div className="body-menu">
        <Menu
          mode="inline"
          theme="dark"
          defaultOpenKeys={["sub1", "sub2"]}
          defaultSelectedKeys={[customMenu.defaultSelectedKeys]}
          items={
            roleRedux == ROLE_ADMIN || roleRedux == ROLE_USER_ADMIN
              ? itemsAdmin
              : getCompanyType() == "BI"
              ? itemsUserBi
              : itemsUser
          }
        />
      </div>
    </Sider>
  );
};

export default MenuApp;
